import * as React from 'react';
import {
	Box,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography,
	useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import PrintIcon from '@mui/icons-material/Print';
import Body from './Body';
import EditIcon from "@mui/icons-material/Edit";

type Props = {
	report: VptReport | null;
	open: boolean;
	onClose: () => void;
};

const Overview: React.FC<Props> = ({ report, open, onClose }) => {
	const theme = useTheme();

	if (!report) {
		return null;
	}

	const reportDate = new Date(report.date);
	const formattedDate = `${String(reportDate.getDate()).padStart(2, '0')}.${String(
		reportDate.getMonth() + 1
	).padStart(2, '0')}.${reportDate.getFullYear()}, ${String(reportDate.getHours()).padStart(
		2,
		'0'
	)}:${String(reportDate.getMinutes()).padStart(2, '0')}`;

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
			<DialogTitle sx={{ p: 0 }}>
				<Box
					sx={{
						p: 2,
						minHeight: 50,
						borderBottom: theme.palette.border,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}>
					<Box>
						<Typography variant="h5" sx={{ ...theme.typography.usersFontTitle,
							fontSize: 20,
						}}>
							{report.inventory ? 'Inventory report' : 'Stocking report'}
						</Typography>
					</Box>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						<EditIcon fontSize="small" sx={{ color: 'green' }} />

						<IconButton aria-label="download" size="small" disabled sx={{ color: 'green' }}>
							<DownloadIcon />
						</IconButton>
						<IconButton aria-label="print" size="small" disabled sx={{ color: 'green' }}>
							<PrintIcon />
						</IconButton>
						<IconButton aria-label="delete" size="small" disabled sx={{ color: 'green' }}>
							<DeleteIcon />
						</IconButton>
						<IconButton aria-label="close" onClick={onClose} size="small" sx={{ color: 'green' }}>
							<CloseIcon />
						</IconButton>
					</Box>
				</Box>
				<Box
					sx={{
						backgroundColor: theme.palette.headerBackground,
						p: 2,
						minHeight: 50,
						borderBottom: theme.palette.border,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}
				>
					<Typography variant="body2" sx={{ fontSize: 16 }}>{report.storageName}</Typography>
					<Box sx={{ textAlign: 'right'}}>
						<Typography variant="body2">{report.reporterName}</Typography>
						<Typography variant="body2" color="text.secondary">
							{formattedDate}
						</Typography>
					</Box>

				</Box>
			</DialogTitle>

			<DialogContent sx={{ p: 3 }}>
				<Body report={report} />
			</DialogContent>
		</Dialog>
	);
};

export default Overview;